var codeblock_default = {
  "blockStyleSpacing": "RaZ0k",
  "codeBlock": "gBFnt RaZ0k",
  "renderedInTable": "AD1Ma"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
